import LazyLoad from "react-lazyload";

const Member = () => {
  const members = [
    {
      id: 1,
      name: "Abud",
      imageUrl: "/image/member/abud.webp",
      link: "https://www.instagram.com/a.budi14",
      text: "Wanita menyukai yang keras, tapi bukan kekerasan",
    },
    {
      id: 2,
      name: "Ridhog",
      imageUrl: "/image/member/ridog.webp",
      link: "https://www.instagram.com/ridho_lucknut04",
      text: "Jangan tertarik jika diperlakukan baik, karna yang berlaku baik belum tentu  hatinya baik",
    },
    {
      id: 3,
      name: "Caplang",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Fik",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Jawir",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Jamet",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Yogi",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Epan",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Ibnu LPG",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Ibnu",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Amin",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
    {
      id: 3,
      name: "Tatang MC",
      imageUrl: "/image/member/caplang.webp",
      link: "https://www.instagram.com/",
      text: "turu",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h2 className="text-3xl font-bold mb-6 text-center">Members</h2>
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {members.map((member) => (
          <div key={member.id} className="flex flex-col items-center">
            <LazyLoad height={200} once>
              {member.imageUrl ? (
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className="rounded-full h-48 w-48 lg:h-64 lg:w-64 object-cover mb-4 lg:mb-0 mx-auto"
                />
              ) : (
                <div className="rounded-full h-48 w-48 lg:h-64 lg:w-64 bg-gray-200 mb-4 lg:mb-0 mx-auto"></div>
              )}
            </LazyLoad>
            <a
              href={member.link}
              className="text-center text-lg font-semibold hover:text-blue-500"
            >
              {member.name}
            </a>
            <p>{member.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Member;
